module.exports = __webpack_public_path__ + "static/error-9d4890760a4ad4c3e8da355059fb3e81.gif";